<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete glasanje?</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deletePoll"
        :disabled="loading"
      >
        <span v-if="!loading">Pošalji</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['poll']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['initTable', 'getPollsByCommunity', 'getAllPolls']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),

    deletePoll() {
      if (this.loading) {
        return;
      }

      this.loadingStarted();

      let memberId;
      if (this.$router.history.current.name === 'communityPolls') {
        memberId = this.$store.getters.getActiveCommunity.member_id;
      } else {
        memberId = this.$store.getters.getCommunities.filter(
          c => c.community_id === this.poll.communityId
        )[0].member_id;
      }

      let deleteRequest = {
        member_id: memberId,
        post_id: this.poll.id
      };

      this.loadingStarted();
      axios
        .post('/post/delete', deleteRequest)
        .then(() => {
          if (this.$router.history.current.name === 'communityPolls') {
            // this.initTable('pollTable');
            if (this.$store.state.table.pollsFilter) {
              this.getPollsByCommunity({
                communityId: this.$store.getters.getActiveCommunity.id,
                memberId: this.$store.getters.getActiveCommunity.member_id
              });
            } else {
              this.getPollsByCommunity({
                communityId: this.$route.params.id
              });
            }
          } else {
            // this.initTable('tableAllPolls');
            this.getAllPolls();
          }

          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped></style>
